import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/logos/logo.png";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Mobile nav background logic
  const navClass = `
    fixed top-0 left-0 right-0 z-40
    transition-colors duration-500 ease-in-out
    ${
      isScrolled || mobileMenuOpen
        ? "bg-black/90 backdrop-blur-md py-4"
        : "bg-transparent py-6"
    }
  `;

  return (
    <motion.nav
      className={navClass}
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut"  }}
    >
      <div className="container flex items-center justify-between px-6 mx-auto">
        <div className="flex items-center space-x-3 ">
          <div className="w-12 h-12 rounded-full bg-[#8ad11c] flex items-center justify-center overflow-hidden">
            <img
              src={logo}
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-white">Synnovara</h2>
            <p className="text-xs text-lime-400">Innovation Hub</p>
          </div>
        </div>

        {/* Desktop menu */}
        <div className="items-center hidden space-x-8 md:flex">
          {["Home", "Project", "Services", "Contact", "About"].map((item) => (
            <a
              key={item}
              href={item === "Home" ? "/" : `/${item}`}
              className="relative text-white transition-colors hover:text-lime-400 group"
            >
              {item}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-lime-400 group-hover:w-full transition-all duration-300" />
            </a>
          ))}
          <a
            href="https://synvoice.synnovara.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 bg-lime-400 hover:bg-lime-300 text-black font-bold px-4 py-2 rounded-lg text-sm transition-all duration-200 hover:shadow-lg hover:shadow-lime-400/30"
          >
            SynVoice
            <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          className="text-white md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden"
          >
            <div className="container flex flex-col px-6 py-4 mx-auto space-y-4">
              {["Home", "Project", "Services", "Contact", "About"].map(
                (item) => (
                  <a
                    key={item}
                    href={item === "Home" ? "/" : `/${item}`}
                    className="text-white transition-colors hover:text-lime-400"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item}
                  </a>
                )
              )}
              <a
                href="https://synvoice.synnovara.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1.5 bg-lime-400 text-black font-bold px-4 py-2 rounded-lg text-sm"
                onClick={() => setMobileMenuOpen(false)}
              >
                SynVoice
                <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
